if (!customElements.get('taily-excluded-marquee')) {
  customElements.define('taily-excluded-marquee', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const init = () => {
        if (!this.isConnected) return;
        this.source = this.querySelector('.ti-exclude__pills');
        if (!this.source) return;
        this.observer = new ResizeObserver(() => {
          if (this.lastWidth !== this.clientWidth) {
            this.lastWidth = this.clientWidth;
            this.build();
          }
        });
        this.observer.observe(this);
        matchMedia('(max-width:749px) and (prefers-reduced-motion:no-preference)')
          .addEventListener('change', () => this.build(), {signal:this.abort.signal});
        document.fonts.ready.then(() => { if (this.isConnected) this.build(); });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true, signal:this.abort.signal});
      else queueMicrotask(init);
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    build() {
      this.querySelector('.ti-exclude__marquee')?.remove();
      this.classList.remove('is-ready');
      const pills = Array.from(this.source?.children || []);
      if (!pills.length || !this.clientWidth) return;
      const marquee = document.createElement('div');
      marquee.className = 'ti-exclude__marquee';
      marquee.setAttribute('aria-hidden', 'true');
      this.appendChild(marquee);
      const clone = pill => {
        const copy = pill.cloneNode(true);
        copy.removeAttribute('data-shopify-editor-block');
        copy.removeAttribute('id');
        return copy;
      };
      for (let rowIndex = 0; rowIndex < Math.min(2, pills.length); rowIndex++) {
        const row = document.createElement('div'); row.className = 'ti-exclude__row';
        const track = document.createElement('div'); track.className = 'ti-exclude__track';
        const group = document.createElement('div'); group.className = 'ti-exclude__group';
        const rowPills = pills.filter((_, index) => index % 2 === rowIndex);
        rowPills.forEach(pill => group.appendChild(clone(pill)));
        track.appendChild(group); row.appendChild(track); marquee.appendChild(row);
        // Repeat a short row until one complete cycle covers the viewport.
        let width = group.getBoundingClientRect().width;
        while (width > 0 && width < this.clientWidth) {
          rowPills.forEach(pill => group.appendChild(clone(pill)));
          width = group.getBoundingClientRect().width;
        }
        track.appendChild(group.cloneNode(true));
        const speed = Number(rowIndex ? this.dataset.speedTwo : this.dataset.speedOne) || 30;
        track.style.setProperty('--ti-marquee-duration', `${Math.max(1, width / speed)}s`);
      }
      this.classList.add('is-ready');
    }
  });
}
